import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'

function InfoChangedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Ajoneuvon tiedot muokattu</h2>
    </div>
  )
}

function ChangeCarInfo(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    vehicleId: props.carInfo.vehicleId,
    registerPlate: props.carInfo.registerPlate,
    phoneNumber: props.carInfo.phoneNumber,
    numberOfSeats: props.carInfo.numberOfSeats,
    priorityGroup: props.carInfo.priorityGroup,
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  // onChange functions
  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e, index) => {
    e.preventDefault()
    const dataToServer = {
      ...userData,
      vehicleId: Number(userData.vehicleId),
      numberOfSeats: Number(userData.numberOfSeats),
    }

    try {
      await axios.put(`${SERVER_URI}/update_vehicle/`, dataToServer, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'UPDATE_VEHICLE',
        data: { newVehicleInfo: userData, index: props.index },
      })
      setShow(!show)
    } catch (err) {
      console.log('Error in updating info', e)
    }
  }

  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Muokkaa ajoneuvon tietoja</h2>
              <form className='changeInfo_form' onSubmit={(e) => doSubmit(e)}>
                <label className='label_add' htmlFor='vehicleId'>
                  Ajoneuvon Id:
                </label>
                {props.carInfo.vehicleId}
                <br />
                <label className='label_add' htmlFor='vehicleRegisterPlate'>
                  Ajoneuvon rekisterinumero:
                </label>
                {props.carInfo.registerPlate}
                <br />
                <label className='label_add' htmlFor='vehicleOldPhonenumber'>
                  Ajoneuvon vanha puhelinnumero:
                </label>
                {props.carInfo.phoneNumber}
                <br />
                <label className='label_add' htmlFor='vehicleNumberOfSeats'>
                  Ajoneuvon istuinten määrä:
                </label>
                {props.carInfo.numberOfSeats} <br />
                <label className='label_add' htmlFor='vehiclePriorityGroup'>
                  Prioriteettiryhmä:
                </label>
                {props.carInfo.priorityGroup} <br />
                <label className='label_add' htmlFor='vehicleNewPhonenumber'>
                  Ajoneuvon uusi puhelinnumero:
                </label>
                <input
                  type='text'
                  id='phoneNumber'
                  name='phoneNumber'
                  onChange={onChange}
                  placeholder='Puhelinnumero'
                ></input>
                <br className='desktop-break' />
                <label className='label_add' htmlFor='vehicleNewRegisterPlate'>
                  Ajoneuvon uusi rekisterinumero:
                </label>
                <input
                  type='text'
                  id='registerPlate'
                  name='registerPlate'
                  onChange={onChange}
                  placeholder='Uusi rekisterinumero'
                ></input>
                <br className='desktop-break' />
                <label className='label_add' htmlFor='vehicleNewNumberOfSeats'>
                  Ajoneuvon istuinten määrä:{' '}
                </label>
                <input
                  type='text'
                  id='numberOfSeats'
                  name='numberOfSeats'
                  onChange={onChange}
                  placeholder='Uusi istuinten määrä'
                ></input>
                <br className='desktop-break' />
                <label className='label_add' htmlFor='vehiclePriorityGroup'>
                  Prioriteettiryhmä:{' '}
                </label>
                <select id='priorityGroup' name='priorityGroup' onChange={onChange} value={userData.priorityGroup}>
                  <option value=''>Valitse prioriteettiryhmä</option>
                  {props.priorityGroups.map((priorityGroup) => (
                    <option key={priorityGroup.group} value={priorityGroup.group}>
                      {`${priorityGroup.group} - ${priorityGroup.delayTime} min`}
                    </option>
                  ))}
                </select>
                <br className='desktop-break' />
                <input type='submit' id='gradient_Button' value='Muokkaa tiedot' />
              </form>
            </div>
          )}
          {show && <InfoChangedMessage handleClose={props.handleClose} />}
        </div>
      </div>
    </div>
  )
}

export default ChangeCarInfo
